__turbopack_context__.v({
  "header-banner": "HeaderBannerMessage-module-scss-module___vpzLW__header-banner",
});
